import "./scss/App.scss";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PasswordReset from "./PasswordReset";
import EmailVerification from "./EmailVerification";

const App = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path="/"
                    Component={() => {
                        window.location.href = "https://hoobs.com";
                        return null;
                    }}
                />
                <Route path="/reset-password" Component={PasswordReset}></Route>
                <Route path="/verify-email" Component={EmailVerification}></Route>
            </Routes>
        </BrowserRouter>
    );
};

export default App;
